import SvgIcon, { IconProps } from './SvgIcon';
import React from 'react';

export default function MentionIcon(props: IconProps) {
  return (
    <SvgIcon {...props}>
      <path d="M15.3 7.8V14c0 .8.4 2.4 2.3 2.4 2.4 0 2.5-2 2.6-2.6 0-.6 2-11-7.3-11-9.2 0-9.3 6.7-9.3 8.3 0 1.5-.2 10 8.3 10 1.7 0 4.2-.5 5.5-1.3m-2-10a3.8 3.8 0 0 0-3.7-2.4C9 7.5 8 9.5 8 12c0 2.4.9 4.5 3.7 4.5 2.9 0 3.6-2.2 3.6-3.7" />
    </SvgIcon>
  );
}
